import React, { useState, useEffect, useMemo, useCallback } from "react";
import ReactTable from "../../components/constantComponent/reactTable/ReactTable";
import {
	Panel,
	PanelHeader,
	PanelBody,
} from "../../components/panel/panel.jsx";
import { useHistory } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import { navigateTo } from "../../util/Util";
import {
	ApiKey,
	ApiUrl,
	WebUrl,
	AccessRight,
	TransactionType,
	TransactionStatus,
	PanelType,
	LanguageKey,
	DEFAULT_PAGE_SIZE,
	ReadWritePermission,
	Role,
} from "../../util/Constant";
import { setBusy, setIdle, showMessage } from "../../redux/AppAction";
import { useDispatch, useSelector } from "react-redux";
import {
	stringIsNullOrEmpty,
	createFormBody,
	numberWithCurrencyFormat,
	createMultiPartFormBody,
} from "../../util/Util";
import { useTranslation } from "react-i18next";
import ApiEngine from "../../util/ApiEngine";
import { AsyncPaginate } from "react-select-async-paginate";
import NavigationButton from "../../components/constantComponent/button/NavigationButton";
import CustomButtonWithIcon from "../../components/pksoft/button";
import FilterInput from "../../components/pksoft/filter-input";
import { checkIfPermissionExist } from "../../util/PermissionChecker";
import queryString from "query-string";

const AdjustmentReview = (props) => {
	const { t } = useTranslation(LanguageKey._PRIMARY);
    const _userData = useSelector(state => state.authState.userData);
	let _history = useHistory();
	const _dispatch = useDispatch();
	const [calendarStartDate, setCalendarStartDate] = useState(
		moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")
	);
	const [calendarEndDate, setCalendarEndDate] = useState(
		moment().endOf("day").format("YYYY-MM-DD HH:mm:ss")
	);

	const [showTransButton, setShowTransButton] = useState(false);
	const [transactionApiUrl, setTransactionApiUrl] = useState("");
	const isCompany =
		_userData.userRoleId === Role._SUPER_COMPANY ||
		_userData.userRoleId === Role._COMPANY;

	const [username, setUsername] = useState("");
	const [label, setLabel] = useState("All");
	const _SELECTED_MEMBER_KEY = "selectedMemberKey";
	const [initFlag, setInitFlag] = useState(false);
	const [textLimit] = useState(2);
	const [isLoadComplete, setLoadComplete] = useState(false);
	const [transactionId, setTransactionId] = useState("");
	const initialSeconds = 5;

	const [seconds, setSeconds] = useState(initialSeconds); // Tracks time left
	const [isActive, setIsActive] = useState(false);

	useEffect(() => {
		sessionStorage.setItem(_SELECTED_MEMBER_KEY, username);
	}, [username]);

	useEffect(() => {
		init();
	}, []);

	useEffect(() => {
		if (initFlag) {
			getUserTransaction();
		}
	}, [initFlag]);

	async function getMemberList(search, loadOptions, { page }) {
		let formattedData = [];

		if (search.length >= textLimit) {
			var responseJson = await ApiEngine.get(
				`${ApiUrl._API_GET_USER_MEMBER_LIST}?&start=${
					(page - 1) * DEFAULT_PAGE_SIZE
				}&count=${DEFAULT_PAGE_SIZE}&keyword=${search}`
			);

			if (responseJson[ApiKey._API_SUCCESS_KEY]) {
				let data = responseJson[ApiKey._API_DATA_KEY]["data"];
				formattedData = data.map((m) => {
					return { label: m.username, value: m.id };
				});
			}
		}
		formattedData.unshift({ label: "All", value: "" });
		return {
			options: formattedData,
			hasMore: formattedData.length == DEFAULT_PAGE_SIZE,
			additional: {
				page: page + 1,
			},
		};
	}

	const init = async () => {
		if (checkIfPermissionExist(AccessRight._ADJUSTMENT_TRANSACTION_PERMISSION, true)) {
			setShowTransButton(true);
		}
		setInitFlag(true);
	};

	useEffect(() => {
		const queryParams = new URLSearchParams(window.location.search);
		const startdate = queryParams.get("startdate") || "";
		const enddate = queryParams.get("enddate") || "";
		const username = queryParams.get("username") || "";
		const transaction = queryParams.get("transactionId") || "";

		if (!stringIsNullOrEmpty(startdate)) {
			setCalendarStartDate(startdate);
		}

		if (!stringIsNullOrEmpty(enddate)) {
			setCalendarEndDate(enddate);
		}

		if (!stringIsNullOrEmpty(username)) {
			setLabel(username);
			setUsername(username);
		}

		if (!stringIsNullOrEmpty(transaction)) {
			setTransactionId(transaction);
		}
	}, []);

	const updateSearchParams = () => {
		const params = new URLSearchParams(window.location.search);
		var selectedUsername = label;

		params.set("startdate", calendarStartDate);
		params.set("enddate", calendarEndDate);
		params.set("username", selectedUsername);
		
		if (!stringIsNullOrEmpty(transactionId)) {
			params.set("transactionId", transactionId);
		} else {
			params.delete("transactionId");
		}

		_history.replace({ search: params.toString() });
	};

	const getUserTransaction = async () => {
		updateSearchParams();
		let fetchUrl = ApiUrl._API_GET_ALL_USER_TRANSACTION;
		fetchUrl +=
			"?startDate=" + calendarStartDate + "&endDate=" + calendarEndDate;
		fetchUrl +=
			"&transactionType=" + TransactionType._ADJUSTMENT + "&v=" + Date.now();

		if (username !== "") {
			fetchUrl += "&username=" + (label == "All" ? "" : label);
		}

		if (transactionId !== "") {
			fetchUrl += "&transactionId=" + transactionId;
		}

		setTransactionApiUrl(fetchUrl);
		setLoadComplete(true);
	};

	let _tableColumns = [
		{
			id: "id",
			Header: t("ID"),
			accessor: "id",
			Footer: () => {
				return (
					<span>
						<b>{t("TOTAL")}: </b>
					</span>
				);
			},
		},
		{
			Header: () => (
				<div style={{ whiteSpace: "unset" }}>
					{t("ADJUSTMENT")} <br /> {t("DATE")}
				</div>
			),
			accessor: "submitTime",
			disableSortBy: true,
			style: {
				whiteSpace: "unset",
				wordBreak: "break-word",
			},
			Cell: ({ row }) => {
				return (
					<>{moment(row.original.submitTime).format("YYYY-MM-DD HH:mm:ss")}</>
				);
			},
		},
		{
			Header: () => (
				<div style={{ whiteSpace: "unset" }}>
					{t("MEMBER")} <br /> {t("USERNAME")}
				</div>
			),
			accessor: "memberUsername",
			disableSortBy: true,
			Cell: ({ row }) => {
				return (
					<div 
						onClick={() => handleUserClicked(row.original)}
						className="cursor-pointer"
					>
						{row.original.memberUsername}
					</div>
				);
			},
		},
		{
			Header: () => (
				<div style={{ whiteSpace: "unset" }}>
					{t("MEMBER")} <br /> {t("FULLNAME")}
				</div>
			),
			accessor: "memberFullName",
			disableSortBy: true,
		},
		{
			Header: t("TYPE"),
			accessor: "receiptReference",
			disableSortBy: true,
			Cell: ({ row }) => {
				if (row.original.amount > 0) {
					return <span>{t("ADD")}</span>;
				} else {
					return <span>{t("DEDUCT")}</span>;
				}
			},
		},
		{
			Header: t("ROLLOVER_TYPE"),
			accessor: "rolloverType",
			disableSortBy: true,
			Cell: ({ row }) => {
				if (row.original.rolloverType) {
                    
					let finalValue="0";

					if (!isNaN(parseFloat(row.original.rolloverType.value))) {
						if (!isNaN(parseFloat(row.original.amount)) && parseFloat(row.original.amount) > 0) {
							finalValue = numberWithCurrencyFormat(parseFloat(row.original.rolloverType.value), 3);
						}
					}

					if(row.original.rolloverType.option==='1'){
						return <span>{t("MULTIPLIER")}<br/>
						<small>x{finalValue}</small>		
						</span>
					}else if(row.original.rolloverType.option==='2'){
                        return <span>{t("FIXED_AMOUNT")}<br/>
						<small>{finalValue}</small>		
						</span>
					}
					return <></>
								
				} else{
					return <></>
				}
			},
		},
		{
			Header: t("ROLLOVER_BALANCE"),
			accessor: "postMemberRollOverBalance",
			disableSortBy: true,
			Cell: ({ row }) => {
				if (row.original.postMemberRollOverBalance > 0) {
					return (
						<>{numberWithCurrencyFormat(parseFloat(row.original.postMemberRollOverBalance), 3)}</>
					);
				} else {
					return (
							<>{numberWithCurrencyFormat(parseFloat(row.original.postMemberRollOverBalance))}</>
					);
				}
			},
		},
		{
			Header: () => <div className="text-right">{t("AMOUNT")}</div>,
			accessor: "amount",
			disableSortBy: true,
			style: {
				textAlign: "right",
			},
			Cell: ({ row }) => {
				if (row.original.amount > 0) {
					return (
						<>{numberWithCurrencyFormat(parseFloat(row.original.amount), 3)}</>
					);
				} else {
					return (
						<span className="text-red">
							{numberWithCurrencyFormat(parseFloat(row.original.amount))}
						</span>
					);
				}
			},
			Footer: ({ page }) => {
				const totalSum = page.reduce((sum, currentValue) => {
					return sum + parseFloat(currentValue.original.amount);
				}, 0);

				return (
					<div className="text-right">
						<b>{numberWithCurrencyFormat(parseFloat(totalSum), 3)}</b>
					</div>
				);
			},
		},
		{
			Header: t("REMARKS"),
			accessor: "remark",
			disableSortBy: true,
		},
		{
			Header: t("STAFF_IN_CHARGE"),
			accessor: "lockedByFullName",
			disableSortBy: true,
		},
	];

	const handleEvent = (event, picker) => {
		setCalendarStartDate(
			moment(picker.startDate).format("YYYY-MM-DD HH:mm:ss")
		);
		setCalendarEndDate(moment(picker.endDate).format("YYYY-MM-DD HH:mm:ss"));
	};

	const isBusy = useSelector((state) => state.appState.isBusy);

	const setRefreshTimeout = useCallback(() => {
		if (!isBusy) {
			if (seconds > 0) {
				setSeconds((prev) => prev - 1);
			}
		}
	}, [isBusy, seconds]);

	// Effect to handle the countdown and reset
	useEffect(() => {
		let timeoutId;
		if (isActive && !isBusy) {
			if (seconds === 0) {
				getUserTransaction();
				setSeconds(initialSeconds); // Reset the countdown
			} else {
				timeoutId = setTimeout(() => {
					setRefreshTimeout();
				}, 1000);
			}
		}

		// Clear timeout on cleanup or dependency change
		return () => clearTimeout(timeoutId);
	}, [isActive, seconds, isBusy, initialSeconds, setRefreshTimeout]);

	// Start or Pause the countdown
	const toggleStartPause = () => {
		setSeconds(initialSeconds);
		setIsActive((prev) => !prev);
	};

	const handleUserClicked = (member) => {
		// Create the URL with query parameters
		let memberDetails = {
			memberId: member.memberId,
			username: member.memberUsername,
		};

		const stateString = queryString.stringify(memberDetails);
		const targetUrl = `${WebUrl._URL_VIEW_ACCOUNT}?${stateString}`;

		// Open the URL in a new tab
		window.open(targetUrl, "_blank");
	};

	return (
		<div>
			<h1 className="page-header">
				{t("ADJUSTMENT_REPORT")}{" "}
			</h1>
			<Panel>
				<PanelBody>
					<div className="row">
						<div className="col-lg-3">
							<FilterInput
								fieldType="DateRangePicker"
								label={t("DATE")+" (UTC+"+_userData.userTimeZone+")"}
								value={calendarStartDate + " - " + calendarEndDate}
								onApply={handleEvent}
								alwaysShowCalendars={true}
								locale={{
									applyLabel: t("APPLY"),
									cancelLabel: t("CANCEL"),
									format: "YYYY-MM-DD HH:mm:ss",
									customRangeLabel: t("CUSTOM_RANGE"),
								}}
								timePicker={true}
								timePickerSeconds={true}
								ranges={{
									[t("TODAY")]: [
										moment().startOf("day"),
										moment().endOf("day"),
									],
									[t("YESTERDAY")]: [
										moment().subtract(1, "days").startOf("day"),
										moment().subtract(1, "days").endOf("day"),
									],
									[t("LAST_7_DAYS")]: [
										moment().subtract(6, "days").startOf("day"),
										moment().endOf("day"),
									],
									[t("LAST_30_DAYS")]: [
										moment().subtract(29, "days").startOf("day"),
										moment().endOf("day"),
									],
									[t("THIS_MONTH")]: [
										moment().startOf("month"),
										moment().endOf("month"),
									],
									[t("LAST_MONTH")]: [
										moment().subtract(1, "month").startOf("month"),
										moment().subtract(1, "month").endOf("month"),
									],
									[t("THIS_YEAR")]: [
										moment().startOf("year"),
										moment().endOf("year"),
									],
								}}
							/>
						</div>

						<div className="col-lg-3">
							<FilterInput
								fieldType="Input"
								label={t("TRANSACTION_ID")}
								type="text"
								value={transactionId}
								placeholder={t("TRANSACTION_ID")}
								onChange={(e) => {
									setTransactionId(e.target.value);
								}}
							/>
						</div>

						{stringIsNullOrEmpty(props.username) && (
							<div className="col-lg-3">
								<FilterInput
									fieldType="AsyncPaginate"
									label={t("USERNAME")}
									placeholder={label}
									debounceTimeout={250}
									options={getMemberList}
									additional={{
										page: 1,
									}}
									value={username}
									onChange={(e) => {
										if (!stringIsNullOrEmpty(e.value)) {
											sessionStorage.setItem(_SELECTED_MEMBER_KEY, e.value);
										} else {
											sessionStorage.removeItem(_SELECTED_MEMBER_KEY);
										}
										setLabel(e.label);
										setUsername(e.label);
									}}
									textLimit={textLimit}
								/>
							</div>
						)}
						<div className="col-lg-12">
							<CustomButtonWithIcon
								onClick={() => {
									getUserTransaction();
								}}
								text={t("SEARCH")}
								icon={<i className="fas fa-search"></i>}
							/>
						</div>
					</div>
				</PanelBody>
			</Panel>
			<Panel>
				{isLoadComplete && (
					<ReactTable
						className=" v2-list-table"
						fetchUrl={transactionApiUrl}
						columns={_tableColumns}
						renderFooter={true}
						globalFilterable={false}
						isParamUrl
					/>
				)}
			</Panel>
		</div>
	);
};

export default AdjustmentReview;
